<script>
	import { createEventDispatcher } from 'svelte'
	const dispatch = createEventDispatcher()
	export let listOptions=[], listsaved=[], className="",classInputName="", errorMessage = ""
	export const clear = () => {
		selection = []
	}
	$:classContainer= className + " cl_tg_inp"
	$:listOptionsloc = listOptions
	let selection=[]
	let listProps = "list-props_"+Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
	$:{ if(listOptions) console.log(listOptions)}
	const handleKeyDown = (e) => {
		if(e.key==="Enter"){
			e.preventDefault()
			let val = e.target.value.trim()
			if(val.length>0){
				//console.log(val)
				selection.push(val)
				if(listOptionsloc.includes(val)){
					listOptionsloc = listOptionsloc.filter(t => t!==val)
					let elem = document.querySelector('#'+listProps).querySelector(`option[value="${val}"]`)
					//console.log(elem)
					if(elem) elem.remove()
					//console.log("listOptionsloc",listOptionsloc)
				}
			}
			dispatch('change',selection)
			e.target.value = ""
		}
		
	}

	const handleDeleteSelected = (tag) => {
		selection = selection.filter(t => t!==tag)
		if(listOptions.includes(tag)){
			let elem = document.querySelector('#'+listProps)
			elem.insertAdjacentHTML('beforeend',`<option value="${tag}">`)
		}
		dispatch('change',selection)
	}
</script>
<div class={classContainer}>
{#if errorMessage.length>0}
<div class="alert">{@html errorMessage}</div>
{/if}
{#each listsaved as sel}
<div class="badge">{sel} <span class="close" on:click={()=>{handleDeleteSelected(sel)}}>X</span></div>
{/each}
<input
	type="text"
	class={classInputName}
	list={listProps}
	on:keydown={handleKeyDown}
>
<datalist id={listProps}>
	{#each listOptions as opt}
	<option value={opt}>
	{/each}
</datalist>
</div>

<style>
	.cl_tg_inp {
		display: flex;
		flex-flow: row wrap;
		align-items: center;
	}
	.cl_sel_visu {
		margin-right: .5em;
	}
	input {
		display: inline-block;
		width: auto;
	}
	.badge {
		display: inline-block;
		padding: .25em .4em;
		margin-right: .5em;
		margin-bottom: .5em;
		font-size: 75%;
		font-weight: 700;
		line-height: 1;
		text-align: center;
		white-space: nowrap;
		vertical-align: baseline;
		border-radius: .25rem;
		color: #fff;
   		background-color: #6c757d;
	}
	.close {
		cursor: pointer;
		display: inline-block;
		margin-left: .5em;
		border: 1px solid #fff;
		border-radius: 50%;
		width: 14px;
		height: 14px;
	}
	.alert {
		position: relative;
		padding: .75rem 1.25rem;
		margin-bottom: 1rem;
		border: 1px solid transparent;
		border-radius: .25rem;
		color: #721c24;
		background-color: #f8d7da;
		border-color: #f5c6cb;
	}
</style>